import React from 'react';
import {
  Grid,
  TextField
} from '@material-ui/core';
import NumberFormat from 'react-number-format';
import { InfoTooltip } from 'components';


const NumberFormatGrid = ({
  name,
  label,
  value,
  onChange,
  suffix = '',
  mask = '',
  InputProps = {},
  classes = '',
  isTooltip = false,
  tooltipTitle
}) => {
  return (
    <Grid container spacing={3} className="ml-2 mb-5 items-center">
      <Grid item xs={12} md={3}>
        {label}
      </Grid>
      <Grid item xs={12} md={8} lg={6} className="text-right flex">
        <NumberFormat
          fullWidth
          allowNegative={false}
          mask={mask}
          suffix={suffix}
          variant="outlined"
          name={name}
          label={label}
          className={classes}
          defaultValue={value}
          onValueChange={(value) => onChange(value.floatValue)}
          customInput={TextField}
          InputProps={InputProps}
        />
        {isTooltip &&
          <InfoTooltip title={tooltipTitle} />
        }
      </Grid>
    </Grid>
  );
};

export default NumberFormatGrid;
